<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-nrs2002
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">营养筛查</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" :scroll-to-error="true">
        <div class="form-item">
          <div class="form-item-label">近2周的饭量是变多还是变少了？</div>
          <div class="form-item-input">
            <van-field name="foodEatChangeFlagTwoWeek" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData.foodEatChangeFlagTwoWeek" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" :key="1" :name="1" checked-color="#FBB13D">变多了</van-radio>
                  <van-radio class="van-radio__label" :key="2" :name="2" checked-color="#FBB13D">基本没变化</van-radio>
                  <van-radio class="van-radio__label" :key="3" :name="3" checked-color="#FBB13D">变少了</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>
        <div v-if="formData.foodEatChangeFlagTwoWeek === 3" class="form-item" key="foodEatLossFlag">
          <div class="form-item-label">饭量少了多少？</div>
          <div class="form-item-input">
            <van-field name="foodEatLossFlag" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData.foodEatLossFlag" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" :key="1" :name="1" checked-color="#FBB13D">少了1/4-1/2</van-radio>
                  <van-radio class="van-radio__label" :key="2" :name="2" checked-color="#FBB13D">少了1/2-3/4</van-radio>
                  <van-radio class="van-radio__label" :key="3" :name="3" checked-color="#FBB13D">少了3/4以上</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>
        <div class="form-item" key="weightChangeFlagTwoWeek">
          <div class="form-item-label">近2周体重是升高还是下降？</div>
          <div class="form-item-input">
            <van-field name="weightChangeFlagTwoWeek" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData.weightChangeFlagTwoWeek" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" :key="1" :name="1" checked-color="#FBB13D">体重升高</van-radio>
                  <van-radio class="van-radio__label" :key="2" :name="2" checked-color="#FBB13D">没变化</van-radio>
                  <van-radio class="van-radio__label" :key="3" :name="3" checked-color="#FBB13D">体重下降</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>
        <div v-if="formData.weightChangeFlagTwoWeek === 3" class="form-item" key="weightLossTimeFlag">
          <div class="form-item-label">体重什么时候开始下降的？</div>
          <div class="form-item-input">
            <van-field name="weightLossTimeFlag" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData.weightLossTimeFlag" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" :key="1" :name="1" checked-color="#FBB13D">1个月内</van-radio>
                  <van-radio class="van-radio__label" :key="2" :name="2" checked-color="#FBB13D">2个月内</van-radio>
                  <van-radio class="van-radio__label" :key="3" :name="3" checked-color="#FBB13D">3个月内</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>
        <div v-if="formData.weightChangeFlagTwoWeek === 3" class="form-item" >
          <div class="form-item-label">体重下降了多少kg？</div>
          <div class="form-item-input input-box">
            <van-field v-model="formData.weightLossMuch" name="weightLossMuch" :rules="[{ required: true, message: '请输入' }]" />
          </div>
        </div>
        <div class="form-item" >
          <div class="form-item-label">是否存在以下情况（可多选）？</div>
          <div class="form-item-input">
            <van-field name="pastMedicalHistorys" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-checkbox-group v-model="formData.pastMedicalHistorys" direction="vertical" icon-size="1.33rem">
                  <van-checkbox class="van-radio__label" :key="1" :name="1" checked-color="#FBB13D">无以下情况</van-checkbox>
                  <van-checkbox class="van-radio__label" :key="2" :name="2" checked-color="#FBB13D">髋关节骨折，慢性疾病有并发症，肝硬化，慢性阻塞性肺疾病，血液透析，肿瘤</van-checkbox>
                  <van-checkbox class="van-radio__label" :key="3" :name="3" checked-color="#FBB13D">腹部大手术，重度肺炎，恶性血液肿瘤</van-checkbox>
                  <van-checkbox class="van-radio__label" :key="4" :name="4" checked-color="#FBB13D">颅脑损伤，骨髓移植，APACHE大于10分的ICU患者</van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
          </div>
        </div>

        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>

    </div>
  </div>
</template>

<script>
export default {
  name: 'NRS2002Form',
  props: {
    initData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: { }
    }
  },
  created() {

  },
  mounted() {
    console.log('this.InitData', this.initData);
    this.formData = {...this.initData}
  },
  methods: {
    onSubmit(values) {
      let query = { ...values }
      console.log('onSubmit', values, query);
      this.$emit('next-step',{type:'nrs2002Form',data:query})
    },
    onClickPrev() {
      console.log('onClickPrev');
      this.$emit('prev-step')
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input.input-box .van-cell {
  width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA;
  padding-left: 16px;
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
